import { apiGet } from '@/features/shared/utils/dataFetching'
import { type KitListResponse, type KitProductsResponse } from '@/features/shop/services/Kits/types'
import { type KitsQueryKey, type KitProductsQueryKey } from '@/features/shop/services/Kits/queries'
import { type QueryFunctionContext } from '@tanstack/react-query'

export const fetchKits = (context: QueryFunctionContext<KitsQueryKey>) => {
  const [, params] = context.queryKey
  return apiGet<KitListResponse>({
    config: {
      url: 'recipes/v1/kits',
      params,
    },
    context,
    fetcherName: 'fetchKits',
  })
}

export const fetchKitProducts = (context: QueryFunctionContext<KitProductsQueryKey>) => {
  const [, { kitId, store_id, metro_id, store_location_id, zip_code }] = context.queryKey
  return apiGet<KitProductsResponse>({
    config: {
      url: `recipes/v1/kits/${kitId}/details`,
      params: { store_id, metro_id, store_location_id, zip_code },
    },
    context,
    options: { ignoredMessages: ['the kit you requested was not found'] },
    fetcherName: 'fetchKitProducts',
  })
}
